/**
 * Which category-in-canton pages exist (/kategorie/fotograf/zuerich/), and how
 * their offer cards are picked. The list is generated by
 * scripts/build-category-regions.js; see that file for the threshold.
 */
import categoryRegions from '../containers/LandingPages/data/categoryRegions.json';
import { CATEGORIES } from '../containers/LandingPages/landingContent';
import { getAuthorId } from './listingCollections';
import { CANTONS, cantonByOption } from './regions';

export const MIN_VENDORS = categoryRegions.minVendors;

/**
 * @param {string} slug category slug
 * @param {string} option canton option key
 * @returns {boolean} whether the pair has a page
 */
export const hasCategoryRegionPage = (slug, option) =>
  (categoryRegions.pages[slug] || []).includes(option);

/** Cantons with a page for this category, in cantons.json order. */
export const cantonsWithPage = slug =>
  (categoryRegions.pages[slug] || []).map(cantonByOption).filter(Boolean);

/** Categories with a page in this canton, in landing-page order. */
export const categoriesWithPage = option =>
  CATEGORIES.filter(cat => hasCategoryRegionPage(cat.slug, option));

const listsEveryCanton = listing =>
  (listing?.attributes?.publicData?.Region || []).length >= CANTONS.length;

/**
 * One listing per vendor, vendors who don't list every canton first. Stable
 * otherwise, so the API's order holds within each group.
 *
 * @param {Array} listings raw or denormalised listings
 * @param {number} [limit]
 * @returns {Array} listings
 */
export const regionalFirst = (listings = [], limit) => {
  const seen = new Set();
  const picked = [
    ...listings.filter(l => !listsEveryCanton(l)),
    ...listings.filter(listsEveryCanton),
  ].filter(listing => {
    const authorId = getAuthorId(listing);
    if (seen.has(authorId)) {
      return false;
    }
    seen.add(authorId);
    return true;
  });
  return typeof limit === 'number' ? picked.slice(0, limit) : picked;
};

/** Distinct vendors among listings that don't list every canton. */
export const regionalVendorCount = (listings = []) =>
  new Set(listings.filter(l => !listsEveryCanton(l)).map(getAuthorId)).size;
